import { collection, query, where, getDocs } from 'firebase/firestore';

export function getStudentFullName(student) {
  return `${student.firstName || ''} ${student.lastName || ''}`.trim() || student.displayName || '';
}

export function studentMatchesQuery(student, query) {
  const q = query.trim().toLowerCase();
  if (!q) return false;

  const fullName = getStudentFullName(student).toLowerCase();
  const yearGroup = (student.yearGroup || '').toLowerCase();
  const matchesNeed = (student.specialNeeds || []).some((need) => need.toLowerCase().includes(q));

  return fullName.includes(q) || yearGroup.includes(q) || matchesNeed;
}

export function rankStudentMatch(student, query) {
  const q = query.trim().toLowerCase();
  const fullName = getStudentFullName(student).toLowerCase();
  const first = (student.firstName || '').toLowerCase();
  const last = (student.lastName || '').toLowerCase();

  if (fullName === q) return 100;
  if (first === q || last === q) return 90;
  if (fullName.startsWith(q)) return 80;
  if (fullName.includes(q)) return 60;
  if ((student.yearGroup || '').toLowerCase().includes(q)) return 30;
  return 10;
}

/**
 * Return the best-matching student when the query is unambiguous, otherwise null.
 */
export function resolveStudentSearch(students, query) {
  const trimmed = query.trim();
  if (!trimmed) return null;

  const matches = students
    .filter((student) => studentMatchesQuery(student, trimmed))
    .sort((a, b) => rankStudentMatch(b, trimmed) - rankStudentMatch(a, trimmed));

  if (matches.length === 0) return null;
  if (matches.length === 1) return matches[0];

  const topScore = rankStudentMatch(matches[0], trimmed);
  const topMatches = matches.filter((student) => rankStudentMatch(student, trimmed) === topScore);

  if (topMatches.length === 1 && topScore >= 70) return topMatches[0];

  return null;
}

export async function fetchStudentsForSchool(db, schoolId) {
  const snapshot = await getDocs(
    query(collection(db, 'students'), where('schoolId', '==', schoolId))
  );
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
}
